<template>
  <div class="animated fadeIn list-kiriman">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add1">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-dropdown text="Export" variant="primary mr-1" >
            <b-dropdown-item @click="exportxls" >Detail Sesuai Faktur kirim</b-dropdown-item>
            <b-dropdown-item @click="exportrekapxls" >Rekap Billing/Induk Customer  </b-dropdown-item>

          </b-dropdown>

          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:90px !important;">Tgl. Edisi</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" placeholder="from date"></b-form-input>
            <b-input-group-append>
              <span class="input-group-text">s.d.</span>
            </b-input-group-append>
            <b-form-input v-model="tblData.tgl2" type="date" placeholder="until date"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:90px !important;">Jenis Kiriman</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.kiriman_name" @change="tblData.kiriman_code=''" placeholder="Jenis Kiriman" style="width:30% !important;" ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranKirimanCodeShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-prepend>
              <span class="pl-2 pt-2 pr-1">Bayar/Tdk.Bayar</span>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.paid" :plain="true" :options="paidUnPaid" ></b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:90px !important;">Jurusan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.jurusan_name"
              @keyup.13.native="lkuKoranJurusanShow=true" 
              @change="tblData.jurusan_id=''" 
            ></b-form-input>
            <b-input-group-append style="height: 35px;">
              <b-btn text="Button" @click="lkuKoranJurusanShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>            
            <b-input-group-prepend>
              <span class="p-2">Kota</span>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.kota_name"
              @keyup.13.native="lkuKoranKotaShow=true"
              @change="tblData.kota_id=''"
            ></b-form-input>
            <b-input-group-append style="height: 35px;">
              <b-btn text="Button" @click="lkuKoranKotaShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>

        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:90px !important;">Agen/pelanggan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.CustName"
              @keyup.13.native="lkuKoranCustShow=true"
              @change="tblData.customer_id=''"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button"  @click="lkuKoranCustShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-form-checkbox v-model="tblData.inclsubagen" value=1 unchecked-value=0 class="pt-2 pr-2">incl.Sub Agen</b-form-checkbox>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width:90px !important;">Sales/AE</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.salesae_name" placeholder="Sales (AE)" @change="tblData.salesid_id=''"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button"  @click="lkuKoranSalesShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-prepend>
              <span class="p-2">Group/Area</span>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.area_name"
              @keyup.13.native="lkuKoranAreaShow=true"
              @change="tblData.area_id=''"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button"  @click="lkuKoranAreaShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <div style="text-align:right;">
                <b-button class="btn btn-success ml-1"  @click="search()">
                  <i class="fa fa-refresh"></i> Apply Filter
                </b-button>
                <b-button class="btn btn-secondary ml-1"   @click="clearFilter()">
                  <i class="fa fa-eraser"></i> Clear Filter
                </b-button>
          </div>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblData.fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
        show-empty
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>          

        <template v-slot:cell(tanggal)="data">
            {{data.item.tanggal | ambilNamaHari}}, {{ data.item.tanggal | moment("DD MMM YYYY") }} 
        </template>
        <template v-slot:cell(DeliveryAddr)="data">
          <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis; width:180px !important; font-size:smaller">
          {{ data.item.DeliveryAddr }}</div>
        </template>

        <template v-slot:cell(gratis)="data">
          <a href="javascript:void(0)" @click.stop="getGratisList(data.item)">
              {{data.item.gratis | numFormat}}
          </a>
        </template>
        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-input-group style="width: 200px;">
              <b-input-group-prepend class="mb-0"><span class="p-2">Limit per page</span></b-input-group-prepend>
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-row align-h="between">
        <b-col lg="8" xl="6">
          <b-input-group>
                <b-input-group-prepend><span class="input-group-text">TOTAL Berbayar</span></b-input-group-prepend>              
                <b-form-input :value="tblData.totpaid | numFormat" readonly class="text-right font-weight-bold"></b-form-input>
                <b-input-group-prepend><span class="input-group-text">Tdk.Berbayar</span></b-input-group-prepend>              
                <b-form-input :value="tblData.totunpaid | numFormat" readonly class="text-right font-weight-bold mr-2"></b-form-input>
                <b-input-group-prepend><span class="input-group-text">TOTAL OC</span></b-input-group-prepend>              
                <b-form-input :value="tblData.totkirim | numFormat" readonly class="text-right font-weight-bold"></b-form-input>
                <b-input-group-prepend><span class="input-group-text">Eksemplar</span></b-input-group-prepend>                 
          </b-input-group>
        </b-col>
        <b-col lg="4" xl="3">
         <b-input-group>
            <b-input-group-prepend><span class="input-group-text">Nilai Berbayar</span></b-input-group-prepend>              
            <b-form-input :value="tblData.kirtotal_val | numFormat('0,0.00')" readonly class="text-right font-weight-bold"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">{{uanguser}}</span></b-input-group-prepend>              
        </b-input-group>
      </b-col>
      </b-row>

    </b-card>

      <b-modal v-model="showDelConfirm" title="Hapus data?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 data akan dihilangkan secara permanen</p>
        <p class="font-weight-bold m-0 text-danger">Peringatan: anda tidak dapat mengembalikan data</p>
      </b-modal>


      <b-modal v-model="kirimanGratisShow" header-bg-variant="primary"  title="Detail Kiriman tdk.Berbayar(Gratis) " size="md" :centered="true" hide-footer>
          <b-input-group>
            <b-input-group-prepend>
              <label>Agen/Langganan</label>
            </b-input-group-prepend>
            <b-form-input class="ml-1" v-model="frmdata.CustName" readonly></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Tgl.Edisi</label>
            </b-input-group-prepend>
            <b-form-input class="ml-1" v-model="frmdata.tanggal" readonly></b-form-input>
          </b-input-group>

        <b-table
                class="mb-0"
                ref="tblKirimanGratis"
                outlined responsive hover
                style="font-size:smaller;"
                :items="kirimanGratis"
                :fields="tblDataGratisan.fields"
                :current-page="tblDataGratisan.page"
                :per-page="tblDataGratisan.limit"
                :sort-by.sync="tblDataGratisan.sortBy"
                :sort-desc.sync="tblDataGratisan.sortDesc"
            >
            <template v-slot:cell(nomor)="data">
              {{ ((tblDataGratisan.page-1)*tblDataGratisan.limit)+data.index +1}}
            </template>
            <template v-slot:cell(enddate)="data">
              <span v-if="(data.item.enddate)">{{ data.item.enddate | moment("DD MMM YYYY") }}</span>
            </template>
        </b-table>
          <b-row>
            <b-col cols="6" style="font-size:smaller;">
              <div>
                Showing {{(tblDataGratisan.page - 1) * tblDataGratisan.limit + 1}}
                to
                <span
                  v-if="((tblDataGratisan.page * tblDataGratisan.limit)>tblDataGratisan.total)"
                >{{tblDataGratisan.total}}</span>
                <span v-else>{{tblDataGratisan.page * tblDataGratisan.limit}}</span>
                of {{tblDataGratisan.total}} entries
              </div>
            </b-col>
            <b-col cols="6">
              <b-pagination
                align="right"  
                :total-rows="tblDataGratisan.total"
                :per-page="tblDataGratisan.limit"
                v-model="tblDataGratisan.page"
              ></b-pagination>
            </b-col>
          </b-row>
        
          <b-row class="justify-content-center mt-1" >
              <b-button variant="primary" ><i class="fa fa-print"></i> Print</b-button>
              <b-button variant="secondary" class="ml-1" @click="kirimanGratisShow=false" > <i class="fa fa-close"></i> Close</b-button>
          </b-row>
      </b-modal>   

      <!-- <b-modal v-model="showCopyFrm" title="Copy Kiriman Koran" :centered="true"  hide-footer>
                <b-input-group >
                    <b-input-group-prepend><label style="width:150px !important;">Copy dari Kiriman Tgl.</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.tgl1" type="date" placeholder="from date" :state="!$v.frmdata.tgl1.$error"></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label style="width:150px !important;">Copy-kan ke Tanggal</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.tgl2" type="date" placeholder="to date" :state="!$v.frmdata.tgl2.$error"></b-form-input>
                </b-input-group>
              <div style="text-align:right; display:blocked" class="mt-3" >
                  <b-button variant="success" @click="copykiriman"><i class="fa fa-files-o"></i> Copy-kan</b-button>
                  <b-button variant="danger" class="ml-1" @click="showCopyFrm=false" > <i class="fa fa-close"></i> Cancel</b-button>
              </div>
      </b-modal>        -->

    <b-modal v-model="lkuKoranCustShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
      <lku-customerkoran @click="onSelectKoranCust"></lku-customerkoran>
    </b-modal>
    <b-modal v-model="lkuKoranKotaShow" size="lg" :hide-footer="true" title="List Kota" :centered="true">
      <lku-kota @click="onSelectKota"></lku-kota>
    </b-modal>
    <b-modal v-model="lkuKoranJurusanShow" size="lg" :hide-footer="true" title="List Jurusan" :centered="true">
      <lku-jurusan @click="onSelectJurusan"></lku-jurusan>
    </b-modal>
      <b-modal v-model="lkuKoranSalesShow" size="lg" :hide-footer="true" title="List Sales" :centered="true">
        <lku-salesae @click="onSelectKoranSales" crudfilter="koran=1"></lku-salesae>
      </b-modal>
    <b-modal v-model="lkuKoranAreaShow" size="md" :hide-footer="true" title="List of Area/Group" :centered="true">
      <lku-area @click="onSelectArea" ></lku-area>
    </b-modal>

      <!-- <b-modal v-model="lkuKoranCollectShow" size="lg" :hide-footer="true" title="List Kolektor" :centered="true">
        <lku-collector @click="onSelectKoranCollect"></lku-collector>
      </b-modal> -->
    <b-modal v-model="lkuKoranKirimanCodeShow" size="lg" :hide-footer="true" title="Jenis Kiriman" :centered="true">
      <lku-koranjeniskiriman @click="onSelectKoranJenisKiriman" ></lku-koranjeniskiriman>
    </b-modal>

      <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>

  </div>
</template>
<style lang="scss">
  .list-kiriman {
    table {
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
}
</style>
<script>
import moment from "moment";
import toastr from "mini-toastr";
// import crud from "../../apis/crud";
import Loading from "vue-loading-overlay";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import koran_kiriman from "../../apis/koran_kirim_pesanan";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuCustomerkoran from "../lookup/lkuKoranCust";
import lkuKota from "../lookup/lkuKoranKota";
import lkuJurusan from "../lookup/lkuKoranJurusan";
import lkuArea from "../lookup/lkuKoranArea";
import lkuKoranjeniskiriman from "../lookup/lkuKoranJenisKiriman";


toastr.init();

export default {
  components: { Loading, lkuCustomerkoran, lkuSalesae, lkuKota,lkuJurusan , lkuArea, lkuKoranjeniskiriman},
  mixins: [validationMixin],
  validations: {
    frmdata: {
      tgl1: { required },
      tgl2: { required }
    }
  },
  filters: {
    ambilNamaHari(tanggal) {
      const namesDay = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
      ];
      const day_ = namesDay[moment(tanggal).day()];
      return day_;
    }
  },  
  data() {
    return {
      // tglaktif: moment().subtract(5,'days').format('YYYY-MM-DD'),
      tglaktif: this.$store.state.user.tglkoran,
      uanguser: this.$store.state.user.matauang,
      isLoading: false,
      showFilter: true,
      showDelConfirm: false,
      showCopyFrm: false,
      frmdata:{tgl1: moment().subtract(1,'days').format('YYYY-MM-DD'), tgl2: moment().format('YYYY-MM-DD')},
      kirimanGratisShow: false,
      kirimanGratis:[],      
      limit:15,
      pagination: false,      
      tblData: {
        fields:[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
            {
              key: "tanggal",
              label: "Tanggal Kiriman",
              thStyle: "width:140px",
              sortable: true
            },
            {
              key: "nofaktur",
              label: "No Faktur",
              sortable: true
            },

            {
              key: "CustCode",
              label: "Kode",
              sortable: true
            },
            {
              key: "CustName",
              label: "Nama Agen",
              sortable: true
            },
            {
              key: "kiriman_name",
              label: "Jenis Kiriman",
              sortable: true
            },
            {
              key: "totpaid",
              label: "Kiriman Berbayar",
              thStyle: "width:60px",
              thClass: "text-center",
              tdClass: "text-center",
              sortable: true
            },
            {
              key: "gratis",
              label: "Kiriman Tdk.Berbayar",
              thStyle: "width:60px",
              thClass: "text-center",
              tdClass: "text-center",
              sortable: true
            },
            // {
            //   key: "titipan",
            //   label: "Kiriman Titipan",
            //   thStyle: "width:60px",
            //   thClass: "text-center",
            //   tdClass: "text-center",
            //   sortable: true
            // },
            {
              key: "totkirim",
              label: "Total Kiriman",
              thStyle: "width:60px",
              thClass: "text-center",
              tdClass: "text-center",
              sortable: true
            },
            {
              key: "DeliveryAddr",
              label: "Alamat Kirim",
              thStyle: "width:200px",
            },
            {
              key: "jurusan_code",
              label: "Rute",
              sortable: true
            },
            {
              key: "titikdrop",
              label: "Titik Drop",
              sortable: true
            },
            {
              key: "kota_name",
              label: "Kota Layanan",
              sortable: true
            },
            {
              key: "salesae_name",
              label: "MA/AE",
              sortable: true
            },
          ],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tanggal",
        sortDesc: false,
        inclsubagen:1,
        tgl1:moment(this.$store.state.user.tglkoran).format('YYYY-MM-DD'),
        tgl2:moment( this.$store.state.user.tglkoran).format('YYYY-MM-DD'),        
      },
      tblDataGratisan: {
        fields:[
        {
          key: "nomor",
          label: "No.",
          thStyle: "width:40px",
        },
        {
          key: "campaignname",
          label: "Uraian Promo/Gratisan",
          sortable: true,
        },
        {
          key: "kiriman_name",
          label: "Jenis Kiriman",
          sortable: true,
        },
        {
          key: "gratis",
          label: "Jml.Gratisan",
          sortable: true
        },
        ],
        page: 1,
        pageOptions: [10, 20, 30, 50, 70, 90, 120],
        limit: 10,
        total: 0,
      },
      lkuKoranCustShow: false,
      lkuKoranSalesShow: false,
      lkuKoranAreaShow: false,
      lkuKoranKotaShow: false,
      lkuKoranJurusanShow: false,
      lkuKoranKirimanCodeShow: false,
      lkuKoranCollectShow: false,
      paidUnPaid:[{value:'', text:'--semua--'},{value:'1', text:'BerBayar'},{value:'2', text:'Tdk.Bayar'}]      
    };
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    }
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },      
  },   
  // created: async function() {
    // const a = await crud.list({ tablename: "koranjeniskiriman", limit: 1000 });
    // this.customer_group = a.reduce((newArr, el, idx) => {
    //   newArr.push({ value: el.kiriman_code, text: el.kiriman_name });
    //   return newArr;
    // }, [{ value: '', text: "-- Semua Jenis --" }]);

    // this.areas = b.reduce((newArr, item) => {
    //   newArr.push({ value: item.area_id, text: item.area_name });
    //   return newArr;
    // }, []);
  // },

  methods: {
    onSelectKoranCust: function(_selected) {
      this.tblData.customer_id = _selected.customer_id;
      this.tblData.CustName = _selected.CustName;
      this.lkuKoranCustShow = false;
    },
    onSelectKoranSales: function(_selected) {
      this.tblData.salesae_id = _selected.salesae_id;
      this.tblData.salesae_name = _selected.salesae_name;
      this.lkuKoranSalesShow = false;
    },
    onSelectArea: async function(_selected) {
      this.tblData.area_id = _selected.area_id;
      this.tblData.area_name = _selected.area_name;
      this.lkuKoranAreaShow = false;
    },
    onSelectKoranJenisKiriman: function(_selected) {
      this.tblData.kiriman_name = _selected.kiriman_name;
      this.tblData.kiriman_code = _selected.kiriman_code;
      this.lkuKoranKirimanCodeShow = false;
    },

    // onSelectKoranCollect: function(_selected) {
    //   this.tblData.collector_codename = _selected.crewnik;
    //   this.lkuKoranCollectShow = false;
    // },
    onSelectKota: function(_selected) {
      this.tblData.kota_id = _selected.kota_id;
      this.tblData.kota_name = _selected.kota_name;
      this.lkuKoranKotaShow = false;
    },
    onSelectJurusan: function(_selected) {
      this.tblData.jurusan_id = _selected.jurusan_id;
      this.tblData.jurusan_name = _selected.jurusan_name;
      this.lkuKoranJurusanShow = false;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.kirimankoran) {
            this.tblData[key] = filter.kirimankoran[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.kirimankoran.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.kirimankoran;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await koran_kiriman.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await koran_kiriman.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },    
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    }, 
    clearFilter() {
      this.tblData.CustName = '';
      this.tblData.customer_id = '';
      this.tblData.customer_group = '';
      this.tblData.kota_id = '';
      this.tblData.kota_name = '';
      this.tblData.area_id = '';
      this.tblData.area_name = '';
      this.tblData.jurusan_id = '';
      this.tblData.jurusan_name = '';
      this.tblData.kiriman_code = '';
      this.tblData.kiriman_name = '';
      this.tblData.nofaktur = '';
      this.tblData.tgl1 = '';
      this.tblData.tgl2 = '';
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','customer_id', 'CustName', 'inclsubagen', 'tgl1', 'tgl2', 'nofaktur', 'createby', 'kota_id', 'kota_name', 'area_id', 'area_name', 'kiriman_code','kiriman_name', 'kirimanKeys', 'jurusan_id', 'jurusan_name', 'salesae_id', 'salesae_name'];
      let filtered = false;
      const kirimankoran={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              kirimankoran[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          kirimankoran.page=this.tblData.page;
          kirimankoran.limit=this.tblData.limit;
          kirimankoran.sortBy=this.tblData.sortBy;
          kirimankoran.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.kirimankoran=kirimankoran;
          this.$store.commit("filter", filter);
      }
    },      
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    // rowPrint(record) {
    //   this.rowClicked(record);
    //     this.print();        
    // },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },      
    add: function(data) {
      this.saveFilter();
      router.push({ name: "koran.prosespesanan" });
    },
    add1: function(data) {
      this.saveFilter();
      router.push({ name: "koran.kirimanfrm" });
    },
    copykiriman: async function(){
      console.log('Copy Kiriman');
      if (this.invalidFrmdata) {
            console.log('validation : ', this.$v.frmdata);
            console.log('frmdata obj : ',this.frmdata);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else  if (moment(this.frmdata.tgl2).format("YYYY-MM-DD")<this.tglaktif) {
                toastr.error("Tanggal transaksi sudah CLOSED", "ERROR MESSAGE",10000);  
              return;    
        } else  {
          this.isLoading = true;
          try {
            let jawaban = false;
            const kirimanSrc = await koran_kiriman.cekkiriman({tanggal: moment(this.frmdata.tgl1).format('YYYY-MM-DD')});
            // console.log(`Kiriman tanggal ${moment(this.frmdata.tgl1).format('DD MMM YYYY')}: `,kirimanSrc);
            this.isLoading = false;
            if (kirimanSrc.totkirim){
                jawaban=false;
                  const pesan = `Data Kiriman tgl.${moment(this.frmdata.tgl1).format('DD MMM YYYY')} Jml.Customer: ${kirimanSrc.totcustomer}, Total Oplah: ${kirimanSrc.totkirim}eks.,                                 
                                 \n Apakah Anda yakin data tersebut dan proses COPY dilanjutkan ?`
                  jawaban = await this.$bvModal.msgBoxConfirm(pesan, {
                    title: 'Please Confirm',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Iya',
                    cancelTitle: 'Tidak',
                    cancelVariant: 'danger',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                  });
                if (jawaban== false ) {
                    return;
                } else {
                    this.isLoading = true;
                    const kirimanDest = await koran_kiriman.cekkiriman({tanggal: moment(this.frmdata.tgl2).format('YYYY-MM-DD')});
                    // console.log(`Kiriman tanggal ${moment(this.frmdata.tgl2).format('DD MMM YYYY')}: `,kirimanDest);
                    this.isLoading = false;
                    if (kirimanDest.totkirim) {
                        jawaban = false;
                        const pesan = `Kiriman Tgl.${moment(this.frmdata.tgl2).format('DD MMM YYYY')} sudah ada, total ${kirimanDest.totkirim} eksemplar, 
                                      Apakah proses COPY tetap akan anda lanjutkan ?`
                        jawaban = await this.$bvModal.msgBoxConfirm(pesan, {
                          title: 'Please Confirm',
                          size: 'md',
                          buttonSize: 'sm',
                          okVariant: 'success',
                          okTitle: 'Iya',
                          cancelTitle: 'Tidak',
                          cancelVariant: 'danger',
                          footerClass: 'p-2',
                          hideHeaderClose: false,
                          centered: true
                        });
                    }
                } 
                
            } else {
                this.isLoading = false;
                toastr.error(`Kiriman tanggal ${moment(this.frmdata.tgl1).format('DD MMM YYYY')} tidak ditemukan, proses tidak bisa dilanjutkan`,'Copy Kiriman Koran',10000);
                return;
            } 
            if (jawaban== true ) {
                this.isLoading = true;
                await koran_kiriman.copykiriman({tgl1: moment(this.frmdata.tgl1).format('YYYY-MM-DD'),tgl2: moment(this.frmdata.tgl2).format('YYYY-MM-DD')});
                this.isLoading = false;
                  const pesan = `Data Kiriman Koran tanggal ${moment(this.frmdata.tgl1).format('DD MMM YYYY')} berhasil di-copy-kan ke tanggal ${moment(this.frmdata.tgl2).format('dddd, DD MMM YYYY')}` 
                  this.$bvModal.msgBoxOk(pesan, {
                    title: 'Information',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                  })
                    .then(value => {
                      this.confirmHasil = value
                    })
                    .catch(err => {
                      // An error occurred
                    })      
                this.showCopyFrm=false;          
                this.refresh();
            }  
          } catch (error) {
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
          }        
      }

    },   
    edit: async function(data) {
      if (this.model.kirimanKey) {
        if (moment(this.model.tanggal).format("YYYY-MM-DD")<this.tglaktif) {
                toastr.error("Tanggal transaksi sudah CLOSED", "ERROR MESSAGE",10000);     
        } else { 
              this.saveFilter();
              router.push({
                name: "koran.kirimanfrm",
                params: { kirimanKey: this.model.kirimanKey }
              });
        }
      } else {
        toastr.warn("Silahkan pilih data yang ingin diubah!");
      }
      // return;
    },
    deleteConfirm(item) {
      if (this.model && this.model.kirimanKey) {
        if (moment(this.model.tangggal).format("YYYY-MM-DD")<this.tglaktif) {
                toastr.error("Tanggal transaksi sudah CLOSED", "ERROR MESSAGE",10000);
        } else { 
                        this.showDelConfirm = true;
        }
      } else {
        toastr.warn("Silahkan pilih data yang ingin dihapus!");
      }
    },
    deleteData: async function() {
      this.isLoading = true;
      try {
        await koran_kiriman.remove(this.model);
        this.isLoading = false;
        this.refresh();
        toastr.success("Data berhasil dihapus");
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    exportxls: async function() {
      this.isLoading = true;
      try {
        const response = await koran_kiriman.exportxls(this.tblData);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'daftar_kiriman.xlsx');
        document.body.appendChild(link);
        link.click();
        // window.location.assign(url);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    exportrekapxls: async function() {
      if ((!((this.tblData.tgl1) && (this.tblData.tgl2)))) {
          toastr.error("Batasan tanggal/edisi harus diisi", "ERROR MESSAGE", 5000);
          return;
      }
      this.isLoading = true;
      try {
        const response = await koran_kiriman.exportrekapxls(this.tblData);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'daftar_kiriman_rekap.xlsx');
        document.body.appendChild(link);
        link.click();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    kirimanGratisan() {
      // if ((this.tblData.customer_group) || (this.tblData.tgl1) || (this.tblData.tgl2) || (this.tblData.CustName)) {
      //     const filter = this.$store.state.filter;
      //     filter.kirimanlist=this.tblData;
      //     this.$store.commit("filter", filter);
      // }
      this.saveFilter();
      router.push({name :'koran.kirimangratis'});
    },
    async getGratisList(data) {
      if (data.gratis) {
        this.rowClicked(data);
        this.frmdata.CustName=data.CustName;
        this.frmdata.CustCode=data.CustCode;
        this.frmdata.tanggal=moment(data.tanggal).format("DD-MMM-YYYY");
          this.isLoading = true;
          try {
            const list = await koran_kiriman.detailGratis(data);
            this.tblData.total=list.length;
            this.kirimanGratis = list;
            this.kirimanGratisShow = true;
            this.isLoading = false;
          } catch (error) {
            this.isLoading = false;
            if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
      } else {
        toastr.warn("Silahkan pilih data Kriman dg jumlah Tdk.berbayar(Gratis) nya tidak NOL!");
      }
    },
    close() {
      router.push({name: "koran.home"});
    }
  }
};
</script>